export default {
  VALIDATION_SAISIES_ADHESION_LOCALES: 1,
  VALIDATION_TRANSFERT_ADHESION_CDPE: 2,
};
